import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import {
  Ch_createTimeWindowInput,
  useChCreateTimeWindowMutation,
  useChCreateTimeWindowMutation$data,
} from "@/modules/patients/services/ch/__generated__/useChCreateTimeWindowMutation.graphql"
import {
  Ch_updateTimeWindowInput,
  useChUpdateTimeWindowMutation$data,
} from "@/modules/patients/services/ch/__generated__/useChUpdateTimeWindowMutation.graphql"
import { useUpdateSwissTimeWindowMutation } from "@/modules/patients/services/ch/useChUpdateTimeWindow"
import { refetchChPatientAgenda } from "@/modules/patients/services/usePatientAgenda"

export const Ch_createTimeWindowMutation = graphql`
  mutation useChCreateTimeWindowMutation($input: Ch_createTimeWindowInput!) {
    ch_createTimeWindow(input: $input) {
      ch_TimeWindow {
        dateFrom
        dateTo
        referralToDoctorName
        referredBy
        referralReason
        id
        patientId
        internalComment
        referralToCareProviderId
        referredByExternalCareProviderId
        progressNoteId
        alternativeTriage
        progressNote {
          id
          episodeOfCareId
          appointment {
            id
            language
          }
          pointOfCare {
            careProviderId
          }
          treatmentPlan {
            title
            followUpInstructions
            recommended
            from
            to
          }
        }
        alternativeTriageEntry {
          id
          phoneNumber
          reason
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useCreateSwissTimeWindowMutation = () => {
  return useMutation<useChCreateTimeWindowMutation>(Ch_createTimeWindowMutation)
}

type TimeWindowMutationArgs = (
  | { kind: "create"; input: Ch_createTimeWindowInput }
  | { kind: "update"; input: Ch_updateTimeWindowInput }
) & {
  onCreateSuccess?: (data: useChCreateTimeWindowMutation$data) => void
  onUpdateSuccess?: (data: useChUpdateTimeWindowMutation$data) => void
  onError?: (error: Error) => void
}

export const useSwissTimeWindowMutation = (patientId: string, language: string) => {
  const [createSwissTimeWindow] = useCreateSwissTimeWindowMutation()
  const [updateSwissTimeWindow] = useUpdateSwissTimeWindowMutation()

  const mutateTimeWindow = (args: TimeWindowMutationArgs) => {
    const { onCreateSuccess, onUpdateSuccess, onError } = args

    if (args.kind === "create") {
      createSwissTimeWindow({
        variables: { input: args.input },
        onCompleted: (data) => {
          if (data.ch_createTimeWindow.errors && data.ch_createTimeWindow.errors.length > 0) {
            onError?.(new Error(data.ch_createTimeWindow.errors[0].message))
            return
          }
          onCreateSuccess?.(data)
          refetchChPatientAgenda(patientId, language)
        },
        onError: (error) => {
          onError?.(error)
        },
      })
    } else {
      updateSwissTimeWindow({
        variables: { input: args.input },
        onCompleted: (data) => {
          if (data.ch_updateTimeWindow.errors && data.ch_updateTimeWindow.errors.length > 0) {
            onError?.(new Error(data.ch_updateTimeWindow.errors[0].message))
            return
          }
          onUpdateSuccess?.(data)
          refetchChPatientAgenda(patientId, language)
        },
        onError: (error) => {
          onError?.(error)
        },
      })
    }
  }

  return { mutateTimeWindow }
}
